import {
  CompareDurationDefinitionInfo,
  CompareFilterDefinitionInfo,
} from '@modules/quantify/components/QuantifyDefinitionInfo';
import { QuantifyQuery } from '@modules/quantify/store/types';
import { CircleRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';

interface GetCompareFieldHeaderTooltipTitleOptions {
  compareTo: QuantifyQuery['compareQuery'];
  compareLabel: string;
  field: 'A' | 'B';
  color: string;
}

export const getCompareFieldHeaderTooltipTitle = ({
  compareTo,
  compareLabel,
  field,
  color,
}: GetCompareFieldHeaderTooltipTitleOptions) => {
  const label = (
    <Stack>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <CircleRounded sx={{ width: 8 }} style={{ color }} />
        <Typography variant="caption" lineHeight="inherit">
          {compareLabel}:
        </Typography>
      </Stack>
    </Stack>
  );

  if (compareTo?.whereClause) {
    return (
      <Stack>
        <Box>{label}</Box>
        <CompareFilterDefinitionInfo shouldHideTooltips compareField={field} />
      </Stack>
    );
  }

  return (
    <Stack>
      <Box>{label}</Box>
      <CompareDurationDefinitionInfo compareField={field} />
    </Stack>
  );
};
